import classNames from 'classnames'
import { forwardRef, LabelHTMLAttributes, ReactNode } from 'react'

import { Slot } from '../utilities/slot/slot'
import type { SwitchSize } from './switch'
import styles from './switch-label.module.scss'

export type SwitchLabelElement = HTMLLabelElement

export interface SwitchLabelProps extends LabelHTMLAttributes<SwitchLabelElement> {
  htmlFor: string
  children: ReactNode
  size?: SwitchSize
  asChild?: boolean
}

const SwitchLabel = forwardRef<SwitchLabelElement, SwitchLabelProps>(function SwitchLabel(
  props,
  forwardedRef
) {
  const { className, children, asChild, size = 'md', ...rest } = props

  const Component = asChild ? Slot : 'label'

  const classes = classNames(
    styles.root,
    {
      [styles[size]]: size,
    },
    className
  )

  return (
    <Component {...rest} data-fds-switch-label className={classes} ref={forwardedRef}>
      {children}
    </Component>
  )
})

export default SwitchLabel
